// extracted by mini-css-extract-plugin
export var heroImage = "_i6-1";
export var modal = "_i6-0";